export const FONT_SIZE_MODIFIER_PREFIX = 'ws-fz-';

export const SUPPORTED_FONT_SIZES = [12, 14, 16, 18, 20, 24, 28, 32, 36, 40, 44, 48, 56, 64];
